import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Submenu } from "./subMenu.component";
import "./subMenuFlyoutPanel.scss";

type SubmenuProps = {
    data: {
        url: string;
        title: string;
        subCategories: any;
    };
    root?: boolean;
    level?: number;
    offsetTop?: number;
    onClick: (active: boolean, item: Object) => void;
    onClose: (e: Event) => void;
};

const SubmenuFlyoutPanel = ({
    data,
    root,
    level = 0,
    offsetTop,
    onClick,
    onClose,
}: SubmenuProps) => {
    const { t } = useGranite();
    const [isClosing, setIsClosing] = useState(false);
    const timer = useRef(null);

    const closePane = (e: any) => {
        setIsClosing(true);
        // @ts-ignore
        timer.current = setTimeout(() => {
            onClose && onClose(e);
        }, 200);
    };

    useEffect(() => {
        return () => {
            timer.current && clearTimeout(timer.current);
        };
    }, []);

    return (
        <div
            className={classnames(
                "sub-menu-flyout-panel-pane",
                isClosing
                    ? "sub-menu-flyout-panel-animate--out"
                    : "sub-menu-flyout-panel-animate--in",
            )}
            style={{
                ...(offsetTop && { paddingTop: `${offsetTop}px` }),
            }}
        >
            <div className={"sidebar__submenu"}>
                <a
                    href="#"
                    className={"sidebar__submenu__back"}
                    onClick={closePane}
                >
                    <i className="las la-angle-left mr-2" />
                    {t("sideBar.link.productRange.back")}
                </a>
                <a href={data.url} className={"sidebar__submenu__title"}>
                    {data.title}
                </a>
            </div>
            <Submenu
                subCategories={data?.subCategories}
                root={root}
                level={level}
                onClick={onClick}
            />
        </div>
    );
};

export { SubmenuFlyoutPanel };
